export const JSON_CONTENT_TYPE = 'application/json'

export const isJsonResponse = contentType => (contentType || '').includes(JSON_CONTENT_TYPE)

export const nonJsonResponseError = (response, contentType) => {
  const error = new Error(`The server returned an unexpected response (HTTP ${response.status})`)
  error.status = response.status
  error.contentType = contentType || ''

  return error
}
